var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AdminLayout',[(_vm.$route.name === 'admin')?_c('AdminActions'):_vm._e(),_c('router-view',{staticStyle:{"min-height":"90vh"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }